import type React from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { addNotification } from 'loot-core/client/actions';
import { send } from 'loot-core/platform/client/fetch';

import { useNavigate } from '../../../hooks/useNavigate';
import { theme } from '../../../style';
import { ButtonWithLoading } from '../../common/Button';
import { Card } from '../../common/Card';
import { Input } from '../../common/Input';
import { Text } from '../../common/Text';
import { View } from '../../common/View';
import { FormField, FormLabel } from '../../forms';

const ResetPassword: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [password1, setPassword1] = useState('');
  const [password2, setPassword2] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false);

  async function onSubmit(e) {
    setErrorMsg('');
    e.preventDefault();
    if (loading) {
      return;
    }

    if (password1.length < 8) {
      setErrorMsg('Your password must be at least 8 characters long');
      return;
    }

    if (password1 === password2) {
      setLoading(true);
      const { error } = await send('subscribe-confirm-reset-password', {
        password: password1,
        token,
      });

      if (error) {
        dispatch(
          addNotification({
            type: 'error',
            message: 'Password reset has failed. Please try again or request a new recovery link.',
          }),
        );
      } else {
        dispatch(
          addNotification({
            type: 'message',
            message: 'Your password has been successfully changed.',
          }),
        );
        navigate('/');
      }
      setLoading(false);
    } else {
      setErrorMsg('The confirm password does not match.');
    }
  }

  return (
    <Card
      style={{ padding: 20, width: 350, alignSelf: 'center', margin: '0 auto' }}
    >
      <h2>Reset your password</h2>
      <form
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          gap: 8,
        }}
        onSubmit={onSubmit}
      >
        <FormField style={{ flex: 1 }}>
          <View style={{ flexDirection: 'row' }}>
            <FormLabel title="New password" htmlFor="password1" />
            &nbsp;<Text style={{ color: theme.errorText }}> * </Text>
          </View>
          <Input
            value={password1}
            type="password"
            name="password1"
            required={true}
            onChange={e => {
              setPassword1(e.target.value.trim());
            }}
          />
        </FormField>
        <FormField style={{ flex: 1 }}>
          <View style={{ flexDirection: 'row' }}>
            <FormLabel title="Confirm new password" htmlFor="password2" />
            &nbsp;<Text style={{ color: theme.errorText }}> * </Text>
          </View>
          <Input
            value={password2}
            type="password"
            name="password2"
            required={true}
            onChange={e => {
              setPassword2(e.target.value.trim());
            }}
          />
        </FormField>

        {errorMsg && <View style={{ color: theme.errorText }}>{errorMsg}</View>}

        <ButtonWithLoading disabled={loading} type="primary">
          Reset password
        </ButtonWithLoading>
      </form>
    </Card>
  );
};
export default ResetPassword;
